<template>
    <div class="m-liveList" :class="isManage ? 'list-host': 'list-watch'">

        <div class="live-wrap" v-for="item in data" :key="item.id">
            <div class="live-item" @click="clickCard(item)">
                <!-- 封面 -->
                <div class="live-banner">
                   <img v-if="item.thumb" class="live-cover" :src="item.thumb" alt="封面">
                   <img v-else class="live-cover" :src="getDefaultThumb(item.id)" alt="封面">

                    <type-tag type="liveType" :id="item.status"></type-tag>
                </div>

                <!-- 文字 -->
                <div class="live-content">
                    <div class="title">
                        <span v-if="item.needPassword" class="need-pwd"><i class="el-icon-lock"></i></span>
                        {{ item.subject }}
                    </div>
                    <div class="info">{{ $t('c.startTime') }}：{{ item.startTime && item.startTime.slice(0, 16) }}</div>
                    <div class="info" v-if="!isManage || [1,4].includes(userType)">{{ $t('live.creator') }}：{{ item.host || $t('c.notAvailable') }}</div>
                </div>

                <!-- 操作 -->
                <ul class="live-toolbar" v-if="isManage">
                    <li class="live-toolbar-item" @click.stop="handleHost(item, 1)">
                        <i class="nucfont inuc-live"></i>
                        <span>开播</span>
                    </li>
                    <li class="live-toolbar-item" @click.stop="handleHost(item, 2)">
                        <i class="nucfont inuc-edit1"></i>
                        <span>编辑</span>
                    </li>
                    <li class="live-toolbar-item" @click.stop="handleHost(item, 3)">
                        <i class="nucfont inuc-delete"></i>
                        <span>删除</span>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="!data.length" class="nodata">
            {{ $t('live.noLive') }}~
        </div>
    </div>
</template>

<script>
import {Ticket} from '@/utils';

export default {
    props: {
        data: {
            type: Array,
            required: true,
        }
    },

    components: {},

    data() {
        return {
            isManage: false,
            userType: Ticket.get().type
        }
    },

    computed: {},

    watch: {
        '$route': {
            handler(to, from) {
                const hostRouter = ['liveHost', 'liveHostAdd', 'liveHostDetail']
                this.isManage = hostRouter.includes(to.name)
            },
            immediate: true
        }
    },

    mounted() {

    },

    methods: {
        clickCard(data) {
            if (this.isManage) {
                this.toHostDetail(data)
            } else {
                this.toLiveRoom(data)
            }
        },

        // 观看直播
        toLiveRoom(data) {
            this.$emit('live-enter', data)
        },

        /**
         * @param id
         * @param type 1开始直播 2编辑直播 3删除直播
         */
        handleHost({id}, type) {
            if (type === 1) {
                this.$emit('host-start', id)
            } else if (type === 2) {
                this.$emit('host-edit', id)
            } else if (type === 3) {
                this.$emit('host-delete', id)
            }
        },

        // 直播详情页
        toHostDetail({id}) {
            this.$emit('host-detail', id)
        },

        getDefaultThumb(id) {
            let lastNumber = String(id).substr(-1,1)
            let imageID = lastNumber % 7  // 0~6

            let url = require(`@/assets/images/live/cover${imageID}.png`)

            return url
        }
    },
}
</script>

<style lang="scss">
.m-liveList {
    @include clearfix;

    .live-wrap {
        float: left;
        width: 25%;
        padding: 10px;
    }

    .live-item {
        position: relative;
        border-radius: 5px;
        //box-shadow: 0 0 4px #ddd;
        border: 1px solid #eee;
        transition: all .3s ease-in-out;
        color: #333;
        cursor: pointer;
        overflow: hidden;

        &:hover {
            //box-shadow: 0 4px 20px #ddd;
            //transform: translateY(-2px);
            .live-cover {
                transform: scale(1.1);
                opacity: .85;
            }

            .live-toolbar {
                transform: translateY(0);
            }
        }
    }

    .live-banner {
        position: relative;
        padding-top: 56.25%;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;

        .live-cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: all .3s ease-in-out;
            object-fit: cover;
        }

        .type-tag {
            position: absolute;
            top: 10px;
            right: 15px;
        }
    }

    .live-content {
        padding: 8px;
        border-top: 1px solid #eee;

        .title {
            line-height: 20px;
            @include no-wrap();
        }

        .info {
            padding-top: 4px;
            font-size: 12px;
            line-height: 18px;
            color: #999;
        }
    }

    $toolbar-height: 60px;

    .live-toolbar {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100%;
        height: $toolbar-height;
        line-height: $toolbar-height;
        background-color: #000;
        opacity: .7;
        transform: translateY($toolbar-height);
        transition: all .3s ease-in-out;

        .live-toolbar-item {
            flex: 1;
            font-size: 14px;
            text-align: center;
            color: #fff;
            > i {
                margin-right: 6px;
                font-size: 13px;
            }
            .inuc-live {
                font-size: 16px;
            }
            &:hover {
                color: $blue;
            }
        }
    }

    &.list-host {
        .live-wrap {
            @media screen and (min-width: 1680px) {
                width: 20%;
            }
        }
    }

    &.list-watch {
        .live-wrap {
            @media screen and (min-width: 1680px) {
                width: 20%;
            }
        }
    }

    .nodata {
        padding-top: 25px;
        padding-bottom: 55px;
        color: #999;
        text-align: center;
        line-height: 400px;
        font-size: 16px;
    }

}
</style>
